import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  heading: {
    marginBottom: 8,
    fontWeight: 500,
    lineHeight: 1.2,
  },
  h1: {
    fontSize: 40,
  },
  h2: {
    fontSize: 32,
  },
  h3: {
    fontSize: 28,
  },
  h4: {
    fontSize: 24,
  },
  h5: {
    fontSize: 20,
  },
  h6: {
    fontSize: 16,
  },
});

export function PDFViewerHeading({
  type,
  title,
  center,
}: {
  type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  title: string;
  center?: boolean;
}) {
  return (
    <View>
      <Text style={[styles.heading, styles[type], center ? { textAlign: 'center' } : {}]}>{title}</Text>
    </View>
  );
}
